import { Link } from "react-router-dom";
import img1 from "./AllImages/1.jpg";
import img2 from "./AllImages/2.jpg";
import img3 from "./AllImages/3.jpg";
import img4 from "./AllImages/4.jpg";
import sale from "./AllImages/sale.jpg";
import "./GridRow1.css";
const GridRow1 = () => {
  return (
    <>
      <div className="GridBox1">
        <Link to="/sale" className="sale">
          <img src={sale} className="sale"></img>
        </Link>
        <Link to="/sale" className="img1">
          <img src={img1} className="img1"></img>
        </Link>
        <Link to="/sale" className="img2">
          <img src={img2} className="img2"></img>
        </Link>
        <Link to="/sale" className="img3">
          <img src={img3} className="img3"></img>
        </Link>
        <Link to="/sale" className="img4">
          <img src={img4} className="img4"></img>
        </Link>
      </div>
    </>
  );
};
export default GridRow1;
